import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4001ec94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " Due to the foreign exchange rate, the amount displayed on your statement might be a little bit different from the real price. ", -1))

import { inject, PropType } from "vue";
import { Row, Col } from "vant";
import CustomButton from "./CustomButton.vue";
import Title from "./Title.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderInfo',
  props: {
  text: {
    type: String,
  },
  orderNo: {
    type: String,
  },
  button: {
    type: Boolean,
    default: false,
  },
  buttonCb: {
    type: Function as PropType<() => void>,
    default() {
      return () => {
        void 0;
      };
    },
  },
},
  setup(__props) {

const isMove = inject("isMove", false);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ 'order-info': _unref(isMove), 'pc-order-info': !_unref(isMove) })
  }, [
    (__props.button)
      ? (_openBlock(), _createBlock(Title, {
          key: 0,
          text: "Your Order Information",
          class: "title"
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Row), {
      type: "flex",
      justify: "space-between",
      class: "order-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Order No.:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), { class: "value" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.orderNo), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    (__props.button)
      ? (_openBlock(), _createBlock(CustomButton, {
          key: 1,
          onClickSubmit: __props.buttonCb
        }, null, 8, ["onClickSubmit"]))
      : _createCommentVNode("", true),
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})